import { useState, useEffect, useRef, useCallback } from "react";

// ─── Mock Data ────────────────────────────────────────────────────────────────

const LOADS = [
  { id:"PLU-2025-00129", origin:"Bakersfield, CA",  destination:"Phoenix, AZ",   driver:"Marcus Reed",  driverId:"d1", status:"In Progress", eta:"14:30", miles:312, weight:"42,000 lbs", width:"14'6\"", speed:80,  lastUpdate:"2 min ago",  fuel:60, temp:"92°F", remaining:"85 mi",  progress:72, flags:["Oversize","Permit Required"] },
  { id:"PLU-2025-00128", origin:"Fresno, CA",       destination:"Las Vegas, NV", driver:"Tanya Brooks", driverId:"d2", status:"In Progress", eta:"15:10", miles:278, weight:"38,500 lbs", width:"12'0\"", speed:62,  lastUpdate:"5 min ago",  fuel:48, temp:"88°F", remaining:"142 mi", progress:48, flags:["Wide Load"] },
  { id:"PLU-2025-00127", origin:"Samut Prakan",     destination:"Ayutthaya",     driver:"Jake Moreno",  driverId:"d3", status:"In Progress", eta:"13:45", miles:489, weight:"51,200 lbs", width:"16'2\"", speed:55,  lastUpdate:"18 min ago", fuel:91, temp:"85°F", remaining:"210 mi", progress:30, flags:["Superload","Police Escort"] },
  { id:"PLU-2025-00126", origin:"Los Angeles, CA",  destination:"Saraburi",      driver:"Sandra Wu",    driverId:"d4", status:"In Progress", eta:"16:20", miles:134, weight:"29,000 lbs", width:"11'8\"", speed:70,  lastUpdate:"1 hr ago",  fuel:85, temp:"90°F", remaining:"67 mi",  progress:60, flags:[] },
  { id:"PLU-2025-00125", origin:"Nonthaburi",       destination:"Pathum Thani",  driver:"—",            driverId:"",   status:"Pending",     eta:"—",     miles:701, weight:"47,800 lbs", width:"15'0\"", speed:0,   lastUpdate:"—",          fuel:0,  temp:"—",    remaining:"—",      progress:0,  flags:["Oversize","Night Restriction"] },
];

const DRIVERS = [
  { id:"d1", name:"Marcus Reed",  avatar:"MR", status:"Active",   lat:35.3733, lng:-119.0187, lastUpdate:"2 min ago",  vehicle:"Kenworth T680",        speed:80, fuel:60, rating:4.8 },
  { id:"d2", name:"Tanya Brooks", avatar:"TB", status:"Active",   lat:36.7468, lng:-119.7726, lastUpdate:"5 min ago",  vehicle:"Peterbilt 579",        speed:62, fuel:48, rating:4.6 },
  { id:"d3", name:"Jake Moreno",  avatar:"JM", status:"On Break", lat:34.0522, lng:-118.2437, lastUpdate:"18 min ago", vehicle:"Freightliner Cascadia", speed:0,  fuel:91, rating:4.9 },
  { id:"d4", name:"Sandra Wu",    avatar:"SW", status:"Off Duty", lat:38.5816, lng:-121.4944, lastUpdate:"1 hr ago",   vehicle:"Volvo VNL",            speed:0,  fuel:85, rating:4.7 },
];

const GPS_ROUTE = [
  {lat:35.3733,lng:-119.0187},{lat:35.1,lng:-118.4},{lat:34.8,lng:-117.9},
  {lat:34.5,lng:-116.9},{lat:34.2,lng:-115.5},{lat:33.8,lng:-114.2},
  {lat:33.5,lng:-113.0},{lat:33.4484,lng:-112.074},
];

const HISTORY = [
  {time:"10:30",status:"Departed",  dot:"green", place:"Bakersfield Warehouse"},
  {time:"11:45",status:"Rest Stop", dot:"blue",  place:"Bang Pa-in"},
  {time:"13:20",status:"In Transit",dot:"amber", place:"Highway 7"},
  {time:"14:30",status:"ETA",       dot:"gray",  place:"Phoenix Warehouse"},
];

const ALERTS = [
  {type:"warn",title:"Vehicle PLU-02-5678 delayed",sub:"Traffic jam on Highway 9",    time:"10 min ago"},
  {type:"warn",title:"Maintenance due in 2 days",  sub:"Vehicle PLU-03-9012",         time:"30 min ago"},
  {type:"info",title:"New order assigned",         sub:"PLU-2025-00130",              time:"1 hr ago"},
];

const MESSAGES_LIST = [
  {name:"Marcus Reed",  avatar:"MR",msg:"Arrived at customer location",    time:"13:25",unread:true},
  {name:"Tanya Brooks", avatar:"TB",msg:"Requesting delivery time update", time:"13:10",unread:true},
  {name:"Sandra Wu",    avatar:"SW",msg:"Vehicle inspection completed",    time:"12:45",unread:false},
];

const CHAT_INIT = [
  {id:"c1",from:"d",text:"Marcus, confirm load pickup at Bakersfield terminal.",ts:"09:14"},
  {id:"c2",from:"r",text:"Confirmed. Load secured, permits in hand. Rolling out now.",ts:"09:17"},
  {id:"c3",from:"d",text:"Watch the Tehachapi grade — 6% down slope. Adjust speed.",ts:"09:19"},
  {id:"c4",from:"r",text:"Roger. Traffic light so far. ETA Phoenix still 14:30.",ts:"10:02"},
  {id:"c5",from:"d",text:"Good. Check in at Barstow rest stop. Fuel log required.",ts:"10:05"},
];

const AUTO_REPLIES = [
  "Copy that, dispatch.","10-4. On it.",
  "Received. Will update at checkpoint.",
  "Roger. Mile marker noted.","All good on my end.",
];

const NAV_ITEMS = [
  {key:"dashboard",label:"Dashboard",   icon:"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"},
  {key:"orders",   label:"Orders",      icon:"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"},
  {key:"tracking", label:"Tracking",    icon:"M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z"},
  {key:"drivers",  label:"Drivers",     icon:"M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"},
  {key:"vehicles", label:"Vehicles",    icon:"M8 17H5a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v3m-1 11a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2h8z"},
  {key:"map",      label:"Map",         icon:"M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"},
  {key:"alerts",   label:"Alerts",      icon:"M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9", badge:5},
  {key:"messages", label:"Messages",    icon:"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"},
  {key:"reports",  label:"Reports",     icon:"M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"},
  {key:"documents",label:"Documents",   icon:"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"},
  {key:"settings", label:"Settings",    icon:"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z"},
];

const STEPS_TOTAL = (GPS_ROUTE.length - 1) * 20;
const lerp = (a,b,t) => a+(b-a)*t;
const tnow = () => new Date().toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",hour12:false});

// ─── SVG Icon ────────────────────────────────────────────────────────────────

function Icon({d,size="w-5 h-5",stroke=1.8}) {
  return (
    <svg className={`${size} flex-shrink-0`} fill="none" stroke="currentColor" strokeWidth={stroke} viewBox="0 0 24 24">
      {d.split(" M").map((seg,i)=>(
        <path key={i} strokeLinecap="round" strokeLinejoin="round" d={i===0?seg:"M"+seg}/>
      ))}
    </svg>
  );
}

// ─── Status Pill ──────────────────────────────────────────────────────────────

function StatusPill({status}) {
  const map={"In Progress":"bg-blue-100 text-blue-700",Pending:"bg-orange-100 text-orange-600",Completed:"bg-green-100 text-green-700",Delayed:"bg-red-100 text-red-600"};
  return <span className={`text-xs px-2 py-0.5 rounded font-semibold whitespace-nowrap ${map[status]||"bg-gray-100 text-gray-600"}`}>{status}</span>;
}

// ─── Tracking Map SVG ─────────────────────────────────────────────────────────

function TrackingMap({simIdx,simProg,simRunning,hlDriver}) {
  const W=600,H=300;
  const minLat=33.0,maxLat=36.5,minLng=-120.5,maxLng=-111.0;
  const tx=lng=>((lng-minLng)/(maxLng-minLng))*W;
  const ty=lat=>(1-(lat-minLat)/(maxLat-minLat))*H;
  const c=GPS_ROUTE[Math.min(simIdx,GPS_ROUTE.length-1)];
  const n=GPS_ROUTE[Math.min(simIdx+1,GPS_ROUTE.length-1)];
  const cLat=lerp(c.lat,n.lat,simProg), cLng=lerp(c.lng,n.lng,simProg);
  const done=Math.min(simIdx*20+Math.round(simProg*20),STEPS_TOTAL);
  const di=Math.floor(done/20),dp=(done%20)/20;
  const donePts=GPS_ROUTE.slice(0,di+1).map(p=>`${tx(p.lng).toFixed(1)},${ty(p.lat).toFixed(1)}`);
  if(di<GPS_ROUTE.length-1){const cc=GPS_ROUTE[di],nn=GPS_ROUTE[di+1];donePts.push(`${tx(lerp(cc.lng,nn.lng,dp)).toFixed(1)},${ty(lerp(cc.lat,nn.lat,dp)).toFixed(1)}`);}
  const routePts=GPS_ROUTE.map(p=>`${tx(p.lng).toFixed(1)},${ty(p.lat).toFixed(1)}`).join(" ");
  const mx=parseFloat(tx(cLng).toFixed(1)), my=parseFloat(ty(cLat).toFixed(1));
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full">
      <rect width={W} height={H} fill="#e8efe8"/>
      {[.25,.5,.75].map(f=><line key={`h${f}`} x1={0} y1={H*f} x2={W} y2={H*f} stroke="#cdd9bc" strokeWidth="1"/>)}
      {[.17,.33,.5,.67,.83].map(f=><line key={`v${f}`} x1={W*f} y1={0} x2={W*f} y2={H} stroke="#cdd9bc" strokeWidth="1"/>)}
      <ellipse cx={140} cy={70} rx={55} ry={22} fill="#c5d5a8" opacity=".5"/>
      <ellipse cx={400} cy={180} rx={70} ry={26} fill="#cddaae" opacity=".4"/>
      <ellipse cx={500} cy={90} rx={45} ry={18} fill="#c5d5a8" opacity=".3"/>
      {[{t:"PATHUM THANI",x:370,y:42,s:8},{t:"NONTHABURI",x:210,y:125,s:8},{t:"Bangkok",x:270,y:188,s:14,w:"600"},{t:"กรุงเทพมหานคร",x:265,y:205,s:9},{t:"SAMUT SAKHON",x:115,y:268,s:7},{t:"SAMUT PRAKAN",x:380,y:278,s:7},{t:"CHACHOENGSAO",x:480,y:215,s:7}].map(l=>(
        <text key={l.t} x={l.x} y={l.y} fontSize={l.s} fontWeight={l.w||"400"} fill={l.w?"#111":"#6b7280"} fontFamily="system-ui" textAnchor="middle">{l.t}</text>
      ))}
      <polyline points={routePts} fill="none" stroke="#16a34a" strokeWidth="2.5" strokeDasharray="5 3" opacity=".55"/>
      {donePts.length>1&&<polyline points={donePts.join(" ")} fill="none" stroke="#16a34a" strokeWidth="3.5"/>}
      {GPS_ROUTE.slice(1,-1).map((p,i)=><circle key={i} cx={tx(p.lng).toFixed(1)} cy={ty(p.lat).toFixed(1)} r="4" fill="#9ca3af" stroke="#fff" strokeWidth="1.5"/>)}
      <circle cx={tx(GPS_ROUTE[0].lng).toFixed(1)} cy={ty(GPS_ROUTE[0].lat).toFixed(1)} r="13" fill="#1d4ed8" stroke="#fff" strokeWidth="2"/>
      <text x={tx(GPS_ROUTE[0].lng).toFixed(1)} y={parseFloat(ty(GPS_ROUTE[0].lat))+5} textAnchor="middle" fontSize="11" fill="#fff">🚛</text>
      <circle cx={tx(GPS_ROUTE[GPS_ROUTE.length-1].lng).toFixed(1)} cy={ty(GPS_ROUTE[GPS_ROUTE.length-1].lat).toFixed(1)} r="13" fill="#ea580c" stroke="#fff" strokeWidth="2"/>
      <text x={tx(GPS_ROUTE[GPS_ROUTE.length-1].lng).toFixed(1)} y={parseFloat(ty(GPS_ROUTE[GPS_ROUTE.length-1].lat))+5} textAnchor="middle" fontSize="11" fill="#fff">🚛</text>
      <circle cx={250} cy={190} r="14" fill="#7c3aed" stroke="#fff" strokeWidth="2"/>
      <text x={250} y={195} textAnchor="middle" fontSize="10" fill="#fff">📍</text>
      <circle cx={mx} cy={my} r="14" fill="#ea580c" stroke="#fff" strokeWidth="2.5"/>
      <text x={mx} y={my+5} textAnchor="middle" fontSize="10" fill="#fff">🚛</text>
      {simRunning&&<circle cx={mx} cy={my} r="20" fill="none" stroke="#ea580c" strokeWidth="2" opacity=".4"><animate attributeName="r" values="14;26;14" dur="1.5s" repeatCount="indefinite"/><animate attributeName="opacity" values=".5;0;.5" dur="1.5s" repeatCount="indefinite"/></circle>}
      {hlDriver&&<><circle cx={tx(hlDriver.lng).toFixed(1)} cy={ty(hlDriver.lat).toFixed(1)} r="12" fill="#a855f7" stroke="#fff" strokeWidth="2"/><text x={tx(hlDriver.lng).toFixed(1)} y={parseFloat(ty(hlDriver.lat))+5} textAnchor="middle" fontSize="9" fill="#fff">{hlDriver.avatar}</text></>}
      <rect x={W-36} y={8} width="26" height="24" rx="4" fill="#fff" stroke="#e2e8f0" strokeWidth="1"/>
      <text x={W-23} y={24} textAnchor="middle" fontSize="16" fill="#374151">+</text>
      <rect x={W-36} y={36} width="26" height="24" rx="4" fill="#fff" stroke="#e2e8f0" strokeWidth="1"/>
      <text x={W-23} y={52} textAnchor="middle" fontSize="16" fill="#374151">−</text>
    </svg>
  );
}

// ─── Order Row ────────────────────────────────────────────────────────────────

function OrderRow({load,selected,onClick}) {
  const iconBg = load.status==='In Progress' ? 'bg-blue-100' :
                 load.status==='Pending'      ? 'bg-orange-100' :
                 load.status==='Completed'    ? 'bg-green-100'  : 'bg-red-100';
  const iconColor = load.status==='In Progress' ? 'text-blue-600' :
                    load.status==='Pending'      ? 'text-orange-500' :
                    load.status==='Completed'    ? 'text-green-600'  : 'text-red-500';
  const rowCls = 'flex items-start gap-3 px-4 py-3 cursor-pointer border-b border-gray-100 transition-colors ' +
                 (selected ? 'bg-blue-50 border-l-2 border-l-blue-600' : 'hover:bg-gray-50');
  return (
    <div onClick={onClick} className={rowCls}>
      <div className={'w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 ' + iconBg}>
        <svg className={'w-5 h-5 ' + iconColor} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 17H5a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v3m-1 11a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2h8z"/>
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <span className="text-sm font-semibold text-gray-900">{load.id}</span>
          <StatusPill status={load.status}/>
        </div>
        <p className="text-xs text-gray-500 mt-0.5 truncate">{load.origin} → {load.destination}</p>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-gray-500">Driver: {load.driver}</span>
          {load.eta !== "—" && (
            <span className="text-xs font-medium text-gray-700 flex items-center gap-1">
              ETA {load.eta}
              <span className="w-1.5 h-1.5 bg-green-500 rounded-full inline-block"/>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Vehicle Detail Card ──────────────────────────────────────────────────────

function VehicleDetailCard({load,driver,simRunning,simSpeed,onClose,onGPSRecall}) {
  if(!load) return <div className="p-4 text-sm text-gray-400">Select a load to view details.</div>;
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm mx-3 mt-3 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <span className="font-semibold text-sm text-gray-800">Vehicle Detail</span>
        <div className="flex items-center gap-1">
          <button className="w-7 h-7 hover:bg-gray-100 rounded-lg flex items-center justify-center text-gray-400">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
          </button>
          <button onClick={onClose} className="w-7 h-7 hover:bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-xl leading-none">×</button>
        </div>
      </div>
      <div className="p-4">
        {/* Header */}
        <div className="flex items-start gap-3 mb-3">
          <div className="w-14 h-11 bg-gray-100 rounded-xl flex items-center justify-center text-2xl flex-shrink-0">🚛</div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-bold text-sm text-gray-900">PLU-01-{load.id.slice(-4)}</span>
              <StatusPill status={load.status}/>
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-amber-400 text-xs">★</span>
              <span className="text-xs font-semibold text-gray-700">{driver?.rating||"—"}</span>
              <span className="text-xs text-gray-400 ml-1">{load.driver}</span>
            </div>
            <p className="text-xs text-gray-500 mt-0.5 truncate">{load.origin} → {load.destination}</p>
            <p className="text-xs text-gray-400">ETA {load.eta} · {load.remaining} remaining</p>
          </div>
        </div>
        {/* Progress */}
        <div className="mb-3">
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full bg-blue-500 rounded-full transition-all duration-500" style={{width:`${load.progress}%`}}/>
          </div>
          <p className="text-xs text-gray-500 mt-1">{load.progress}%</p>
        </div>
        {/* Actions */}
        <div className="grid grid-cols-4 gap-2 mb-4">
          {[
            "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
            "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z",
            "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z",
          ].map((d,i)=>(
            <button key={i} className="h-9 bg-gray-50 hover:bg-gray-100 rounded-lg flex items-center justify-center text-gray-500 transition-colors">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d={d}/></svg>
            </button>
          ))}
          <button className="h-9 bg-gray-50 hover:bg-gray-100 rounded-lg flex items-center justify-center text-gray-500 font-bold text-base transition-colors">···</button>
        </div>
        {/* Stats */}
        <div className="grid grid-cols-4 gap-2 mb-4 py-3 border-t border-b border-gray-100">
          {[
            {lbl:"SPEED",  val:simRunning?`${simSpeed} km/h`:`${load.speed} km/h`},
            {lbl:"UPDATED",val:load.lastUpdate},
            {lbl:"FUEL",   val:`${load.fuel}%`},
            {lbl:"TEMP",   val:load.temp},
          ].map(s=>(
            <div key={s.lbl} className="text-center">
              <p className="text-[9px] text-gray-400 font-medium tracking-wider">{s.lbl}</p>
              <p className="text-xs font-bold text-gray-800 mt-0.5">{s.val}</p>
            </div>
          ))}
        </div>
        {/* Recent History */}
        <div>
          <div className="flex items-center justify-between mb-2.5">
            <span className="text-sm font-semibold text-gray-800">Recent History</span>
            <button onClick={onGPSRecall} className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors">
              📡 GPS Recall
            </button>
          </div>
          <div className="space-y-2.5">
            {HISTORY.map((h,i)=>(
              <div key={i} className="flex items-center gap-3 text-xs">
                <span className="text-gray-400 font-mono text-[10px] w-9 flex-shrink-0">{h.time}</span>
                <span className={`w-2 h-2 rounded-full flex-shrink-0 ${h.dot==="green"?"bg-green-500":h.dot==="blue"?"bg-blue-500":h.dot==="amber"?"bg-amber-400":"bg-gray-300"}`}/>
                <span className="font-semibold text-gray-700 w-16 flex-shrink-0">{h.status}</span>
                <span className="text-gray-400 truncate">{h.place}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Alerts List ──────────────────────────────────────────────────────────────

function AlertsList() {
  return (
    <div className="px-3 py-3">
      <div className="flex items-center justify-between mb-2">
        <span className="font-semibold text-sm text-gray-800">Alerts</span>
        <button className="text-xs text-blue-600 font-medium hover:text-blue-800">View all</button>
      </div>
      <div className="space-y-2">
        {ALERTS.map((a,i)=>(
          <div key={i} className="flex items-start gap-2.5 bg-white rounded-xl p-3 border border-gray-100">
            <div className={`w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 ${a.type==="warn"?"bg-orange-100":"bg-blue-100"}`}>
              <span className="text-sm">{a.type==="warn"?"⚠️":"ℹ️"}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-gray-800 leading-snug">{a.title}</p>
              <p className="text-xs text-gray-400 mt-0.5">{a.sub}</p>
            </div>
            <span className="text-[10px] text-gray-300 flex-shrink-0 whitespace-nowrap">{a.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Messages List ────────────────────────────────────────────────────────────

function MessagesList({onOpenChat}) {
  return (
    <div className="px-3 py-3">
      <div className="flex items-center justify-between mb-2">
        <span className="font-semibold text-sm text-gray-800">Messages</span>
        <button className="text-xs text-blue-600 font-medium hover:text-blue-800">View all</button>
      </div>
      <div className="space-y-2">
        {MESSAGES_LIST.map((m,i)=>(
          <button key={i} onClick={()=>onOpenChat(m)} className="w-full flex items-center gap-2.5 bg-white rounded-xl p-3 border border-gray-100 hover:border-blue-200 transition-colors text-left">
            <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center font-bold text-blue-700 text-sm flex-shrink-0">{m.avatar}</div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-gray-800">{m.name}</p>
              <p className="text-xs text-gray-400 truncate mt-0.5">{m.msg}</p>
            </div>
            <div className="flex flex-col items-end gap-1 flex-shrink-0">
              <span className="text-[10px] text-gray-300">{m.time}</span>
              {m.unread&&<span className="w-2 h-2 bg-blue-500 rounded-full"/>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── Chat Panel ───────────────────────────────────────────────────────────────

function ChatPanel({driver}) {
  const [msgs,setMsgs]=useState(CHAT_INIT);
  const [inp,setInp]=useState("");
  const endRef=useRef(null);
  useEffect(()=>{endRef.current?.scrollIntoView({behavior:"smooth"});},[msgs]);
  const send=()=>{
    if(!inp.trim())return;
    setMsgs(p=>[...p,{id:`m${Date.now()}`,from:"d",text:inp.trim(),ts:tnow()}]);
    setInp("");
    setTimeout(()=>setMsgs(p=>[...p,{id:`mr${Date.now()}`,from:"r",text:AUTO_REPLIES[Math.floor(Math.random()*AUTO_REPLIES.length)],ts:tnow()}]),800+Math.random()*600);
  };
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-100 bg-gray-50 flex-shrink-0">
        <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center font-bold text-blue-700 text-sm flex-shrink-0">{driver?.avatar||"?"}</div>
        <div>
          <p className="text-sm font-semibold text-gray-800">{driver?.name||"Driver"}</p>
          <div className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 bg-green-500 rounded-full"/><span className="text-xs text-green-600">Online</span></div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
        {msgs.map(m=>(
          <div key={m.id} className={`flex ${m.from==="d"?"justify-end":"justify-start"}`}>
            <div className={`flex flex-col ${m.from==="d"?"items-end":"items-start"} max-w-[80%]`}>
              <div className={`px-3 py-2 rounded-2xl text-sm leading-relaxed ${m.from==="d"?"bg-gray-100 text-gray-800 rounded-br-sm":"bg-blue-600 text-white rounded-bl-sm"}`}>{m.text}</div>
              <span className="text-[10px] text-gray-300 mt-1 px-1">{m.ts}</span>
            </div>
          </div>
        ))}
        <div ref={endRef}/>
      </div>
      <div className="px-3 py-3 border-t border-gray-100 flex-shrink-0">
        <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2 bg-gray-50">
          <span className="text-gray-400 text-lg cursor-pointer">📎</span>
          <input value={inp} onChange={e=>setInp(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()} placeholder="Type a message..." className="flex-1 bg-transparent text-sm text-gray-800 placeholder-gray-300 outline-none min-w-0"/>
          <button onClick={send} disabled={!inp.trim()} className="bg-blue-600 hover:bg-blue-700 disabled:opacity-40 text-white text-xs px-3 py-1.5 rounded-lg font-semibold transition-colors flex-shrink-0">Send</button>
        </div>
      </div>
    </div>
  );
}

// ─── GPS Recall Modal ─────────────────────────────────────────────────────────

function GPSModal({simIdx,simProg,simRunning,onClose,onViewMap}) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{background:"rgba(0,0,0,0.5)"}}>
      <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh]">
        <div className="flex items-center justify-between px-5 py-4 border-b flex-shrink-0">
          <div><h2 className="font-bold text-gray-900">GPS Recall</h2><p className="text-xs text-gray-400 mt-0.5">Live positions — all drivers</p></div>
          <div className="flex items-center gap-2">
            <button className="text-sm border border-gray-200 rounded-lg px-3 py-1.5 hover:bg-gray-50 text-gray-600 font-medium">↻ Refresh</button>
            <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-400 text-xl">×</button>
          </div>
        </div>
        <div className="overflow-y-auto divide-y flex-1">
          {DRIVERS.map(d=>(
            <div key={d.id} className="flex items-center gap-3 px-5 py-3.5 hover:bg-gray-50">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center font-bold text-blue-700 text-sm flex-shrink-0">{d.avatar}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-sm text-gray-800">{d.name}</span>
                  <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${d.status==="Active"?"bg-green-100 text-green-700":d.status==="On Break"?"bg-amber-100 text-amber-700":"bg-gray-100 text-gray-500"}`}>{d.status}</span>
                </div>
                <p className="text-xs text-gray-400 font-mono mt-0.5">{d.lat.toFixed(4)}°N, {Math.abs(d.lng).toFixed(4)}°W</p>
                <p className="text-xs text-gray-300">Last update: {d.lastUpdate}</p>
              </div>
              <button onClick={()=>onViewMap(d)} className="text-xs bg-blue-50 text-blue-700 border border-blue-200 px-3 py-1.5 rounded-lg hover:bg-blue-100 font-medium flex-shrink-0">View on Map</button>
            </div>
          ))}
        </div>
        <div className="px-5 py-3 border-t flex-shrink-0">
          <button onClick={onClose} className="w-full border border-gray-200 text-gray-700 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50">Close</button>
        </div>
      </div>
    </div>
  );
}

// ─── Map Popup Modal ──────────────────────────────────────────────────────────

function MapPopupModal({driver,simIdx,simProg,simRunning,onClose}) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{background:"rgba(0,0,0,0.5)"}}>
      <div className="bg-white w-full sm:max-w-lg sm:rounded-2xl rounded-t-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <div><h2 className="font-bold text-gray-900">📍 {driver.name}</h2><p className="text-xs text-gray-400">{driver.vehicle} · {driver.status}</p></div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-400 text-xl">×</button>
        </div>
        <div className="h-48 border-b"><TrackingMap simIdx={simIdx} simProg={simProg} simRunning={simRunning} hlDriver={driver}/></div>
        <div className="px-5 py-4">
          <div className="grid grid-cols-4 gap-3 text-xs mb-4">
            <div><p className="text-gray-400">Lat</p><p className="font-mono font-semibold text-gray-800 mt-0.5">{driver.lat.toFixed(4)}°</p></div>
            <div><p className="text-gray-400">Lng</p><p className="font-mono font-semibold text-gray-800 mt-0.5">{Math.abs(driver.lng).toFixed(4)}°</p></div>
            <div><p className="text-gray-400">Speed</p><p className="font-semibold text-amber-700 mt-0.5">{driver.speed} mph</p></div>
            <div><p className="text-gray-400">Fuel</p><p className="font-semibold text-green-700 mt-0.5">{driver.fuel}%</p></div>
          </div>
          <button onClick={onClose} className="w-full border border-gray-200 text-gray-700 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50">Close Map</button>
        </div>
      </div>
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────

export default function DispatcherConsole() {
  const [activeNav,      setActiveNav]     = useState("dashboard");
  const [selectedLoad,   setSelectedLoad]  = useState(LOADS[0]);
  const [orderFilter,    setOrderFilter]   = useState("In Progress");
  const [rightTab,       setRightTab]      = useState("detail");
  const [gpsModal,       setGpsModal]      = useState(false);
  const [mapPopupDrv,    setMapPopupDrv]   = useState(null);
  const [detailOpen,     setDetailOpen]    = useState(true);
  const [simRunning,     setSimRunning]    = useState(false);
  const [simIdx,         setSimIdx]        = useState(0);
  const [simProg,        setSimProg]       = useState(0);
  const [simSpeed,       setSimSpeed]      = useState(0);
  const [sidebarOpen,    setSidebarOpen]   = useState(false);
  // Mobile bottom nav: "orders" | "map" | "detail" | "chat"
  const [mobileView,     setMobileView]    = useState("dashboard");

  const simRef = useRef(null);

  // Derived
  const stepsCompleted = Math.min(simIdx*20+Math.round(simProg*20),STEPS_TOTAL);
  const pct    = Math.round((stepsCompleted/STEPS_TOTAL)*100);
  const etaMins= Math.max(0,Math.round(((STEPS_TOTAL-stepsCompleted)/STEPS_TOTAL)*320));
  const selectedDriver = selectedLoad ? DRIVERS.find(d=>d.id===selectedLoad.driverId) : null;
  const filteredLoads  = orderFilter==="All" ? LOADS : LOADS.filter(l=>l.status===orderFilter);

  // Simulation
  useEffect(()=>{
    if(simRunning){
      simRef.current=setInterval(()=>{
        setSimSpeed(Math.floor(52+Math.random()*22));
        setSimProg(prev=>{
          if(prev>=1){setSimIdx(i=>{if(i>=GPS_ROUTE.length-2){setSimRunning(false);return i;}return i+1;});return 0;}
          return prev+0.05;
        });
      },350);
    } else {clearInterval(simRef.current);if(!simRunning)setSimSpeed(0);}
    return ()=>clearInterval(simRef.current);
  },[simRunning]);

  const resetSim=()=>{setSimRunning(false);setSimIdx(0);setSimProg(0);setSimSpeed(0);};

  const handleSelectLoad=(load)=>{
    setSelectedLoad(load);
    setDetailOpen(true);
    setMobileView("detail");
  };

  const openGPSRecall=()=>setGpsModal(true);

  // Summary card data
  const summaryCards=[
    {label:"Total Orders",   val:128,    sub:"vs yesterday",  delta:"↑ 12%", up:true,  icon:"📋",color:"blue"},
    {label:"In Progress",    val:96,     sub:"vs yesterday",  delta:"↑ 8%",  up:true,  icon:"🚛",color:"blue"},
    {label:"Delivered",      val:24,     sub:"vs yesterday",  delta:"↑ 5%",  up:true,  icon:"✅",color:"green"},
    {label:"Delayed",        val:8,      sub:"vs yesterday",  delta:"↓ 3%",  up:false, icon:"⏱",color:"red"},
    {label:"Active Vehicles",val:"42/60",sub:null,            delta:null,    up:null,  icon:"🚗",color:"purple",prog:70},
  ];

  // ── SHARED: Right Panel Content ──
  const RightPanelContent = ()=>(
    <>
      {/* Tab Bar */}
      <div className="flex border-b border-gray-200 bg-white flex-shrink-0 sticky top-0 z-10">
        {["detail","chat","alerts","messages"].map(t=>(
          <button key={t} onClick={()=>setRightTab(t)} className={`flex-1 py-3 text-xs font-semibold capitalize transition-colors border-b-2 ${rightTab===t?"border-blue-600 text-blue-700":"border-transparent text-gray-400 hover:text-gray-700"}`}>
            {t.charAt(0).toUpperCase()+t.slice(1)}
          </button>
        ))}
      </div>

      {/* Detail */}
      {rightTab==="detail"&&(
        <div className="overflow-y-auto flex-1">
          {detailOpen&&<VehicleDetailCard load={selectedLoad} driver={selectedDriver} simRunning={simRunning} simSpeed={simSpeed} onClose={()=>setDetailOpen(false)} onGPSRecall={openGPSRecall}/>}
          {!detailOpen&&<div className="p-3"><button onClick={()=>setDetailOpen(true)} className="text-sm text-blue-600 hover:underline">Show vehicle detail</button></div>}
          <AlertsList/>
          <MessagesList onOpenChat={()=>setRightTab("chat")}/>
        </div>
      )}
      {rightTab==="chat"&&(
        <div className="flex-1 flex flex-col overflow-hidden">
          <ChatPanel driver={selectedDriver}/>
        </div>
      )}
      {rightTab==="alerts"&&(
        <div className="overflow-y-auto flex-1">
          <div className="p-3 space-y-2">
            <h3 className="font-semibold text-sm text-gray-800 mb-3">All Alerts</h3>
            {ALERTS.map((a,i)=>(
              <div key={i} className="flex items-start gap-2.5 bg-white rounded-xl p-3 border border-gray-100">
                <div className={`w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 ${a.type==="warn"?"bg-orange-100":"bg-blue-100"}`}><span className="text-sm">{a.type==="warn"?"⚠️":"ℹ️"}</span></div>
                <div className="flex-1 min-w-0"><p className="text-xs font-semibold text-gray-800">{a.title}</p><p className="text-xs text-gray-400 mt-0.5">{a.sub}</p></div>
                <span className="text-[10px] text-gray-300 flex-shrink-0">{a.time}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {rightTab==="messages"&&(
        <div className="overflow-y-auto flex-1">
          <div className="p-3 space-y-2">
            <h3 className="font-semibold text-sm text-gray-800 mb-3">Messages</h3>
            {MESSAGES_LIST.map((m,i)=>(
              <button key={i} onClick={()=>setRightTab("chat")} className="w-full flex items-center gap-2.5 bg-white rounded-xl p-3 border border-gray-100 hover:border-blue-200 transition-colors text-left">
                <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center font-bold text-blue-700 text-sm flex-shrink-0">{m.avatar}</div>
                <div className="flex-1 min-w-0"><p className="text-xs font-semibold text-gray-800">{m.name}</p><p className="text-xs text-gray-400 truncate mt-0.5">{m.msg}</p></div>
                <div className="flex flex-col items-end gap-1 flex-shrink-0"><span className="text-[10px] text-gray-300">{m.time}</span>{m.unread&&<span className="w-2 h-2 bg-blue-500 rounded-full"/>}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden" style={{fontFamily:"Inter,system-ui,sans-serif"}}>

      {/* ── SIDEBAR overlay (mobile) ── */}
      {sidebarOpen&&<div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={()=>setSidebarOpen(false)}/>}

      {/* ── SIDEBAR ── */}
      <aside className={`fixed lg:relative z-50 lg:z-auto top-0 left-0 h-full w-56 flex-shrink-0 flex flex-col transition-transform duration-300 ${sidebarOpen?"translate-x-0":"-translate-x-full lg:translate-x-0"}`} style={{background:"#1a2744"}}>
        {/* Logo */}
        <div className="flex items-center gap-2.5 px-4 py-4 border-b border-white/10 flex-shrink-0">
          <div className="w-9 h-9 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 17H5a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v3m-1 11a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2h8z"/></svg>
          </div>
          <span className="font-bold text-white text-base tracking-wide">DISPATCHER</span>
          <button onClick={()=>setSidebarOpen(false)} className="ml-auto lg:hidden text-white/50 hover:text-white">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </div>
        {/* Nav */}
        <nav className="flex-1 px-2 py-3 overflow-y-auto space-y-0.5">
          {NAV_ITEMS.map(({key,label,icon,badge})=>(
            <button key={key} onClick={()=>{setActiveNav(key);setSidebarOpen(false);}} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all ${activeNav===key?"bg-blue-600 text-white":"text-gray-300 hover:bg-white/10 hover:text-white"}`}>
              <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                {icon.split(" M").map((seg,i)=><path key={i} strokeLinecap="round" strokeLinejoin="round" d={i===0?seg:"M"+seg}/>)}
              </svg>
              <span className="truncate">{label}</span>
              {badge&&<span className="ml-auto bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full flex-shrink-0">{badge}</span>}
            </button>
          ))}
        </nav>
        {/* Summary */}
        <div className="mx-3 mb-2 rounded-xl p-3 border border-white/10 flex-shrink-0" style={{background:"rgba(255,255,255,0.05)"}}>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2">Today Summary</p>
          {[["Total Orders",128],["In Progress",96],["Delivered",24],["Delayed",8]].map(([l,v])=>(
            <div key={l} className="flex justify-between items-center py-0.5">
              <span className="text-xs text-gray-400">{l}</span>
              <span className={`text-xs font-bold ${l==="Delayed"?"text-red-400":"text-white"}`}>{v}</span>
            </div>
          ))}
        </div>
        {/* New Order */}
        <div className="px-3 pb-4 flex-shrink-0">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2">Quick Action</p>
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-xl text-sm font-bold transition-colors flex items-center justify-center gap-2">
            <span className="text-base">+</span> New Order
          </button>
        </div>
      </aside>

      {/* ── MAIN CONTENT ── */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">

        {/* ── TOPBAR ── */}
        <header className="h-14 bg-white border-b border-gray-200 flex items-center px-3 sm:px-5 gap-3 flex-shrink-0 z-30">
          <button onClick={()=>setSidebarOpen(true)} className="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 rounded-lg lg:hidden">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/></svg>
          </button>
          <h1 className="text-lg font-bold text-gray-900">Dashboard</h1>
          {/* Search — hidden on small mobile */}
          <div className="flex-1 max-w-sm mx-4 hidden sm:flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">
            <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
            <input placeholder="Search by order, driver, truck, location..." className="flex-1 bg-transparent text-sm text-gray-600 placeholder-gray-300 outline-none min-w-0"/>
            <span className="text-xs text-gray-300 border border-gray-200 rounded px-1">/</span>
          </div>
          <div className="ml-auto flex items-center gap-1 sm:gap-3">
            <button className="relative w-9 h-9 hover:bg-gray-100 rounded-xl flex items-center justify-center text-gray-500">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg>
              <span className="absolute top-1.5 right-1.5 w-3.5 h-3.5 bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center">3</span>
            </button>
            <button className="w-9 h-9 hover:bg-gray-100 rounded-xl items-center justify-center text-gray-500 hidden sm:flex">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
            </button>
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-sm">D</div>
              <div className="hidden md:block">
                <p className="text-sm font-semibold text-gray-800 leading-tight">Dispatcher</p>
                <div className="flex items-center gap-1"><span className="w-1.5 h-1.5 bg-green-500 rounded-full"/><span className="text-xs text-green-600">Online</span></div>
              </div>
              <svg className="w-4 h-4 text-gray-400 hidden md:block" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/></svg>
            </div>
          </div>
        </header>

        {/* ── DESKTOP BODY ── */}
        <div className="flex-1 overflow-hidden hidden lg:flex">

          {/* LEFT SCROLL AREA */}
          <div className="flex-1 overflow-y-auto flex flex-col min-w-0">

            {/* Summary Cards */}
            <div className="grid grid-cols-5 gap-3 p-4 pb-3 flex-shrink-0">
              {summaryCards.map((c,i)=>(
                <div key={i} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                  <div className="flex items-start justify-between mb-2">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-lg ${c.color==="blue"?"bg-blue-50":c.color==="green"?"bg-green-50":c.color==="red"?"bg-red-50":"bg-purple-50"}`}>{c.icon}</div>
                    {c.delta&&<span className={`text-xs font-semibold ${c.up?"text-green-600":"text-red-500"}`}>{c.delta}</span>}
                  </div>
                  <p className="text-xs text-gray-400 font-medium">{c.label}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-0.5">{c.val}</p>
                  {c.sub&&<p className="text-xs text-gray-400 mt-0.5">{c.sub}</p>}
                  {c.prog!=null&&<div className="mt-2"><div className="h-1.5 bg-gray-100 rounded-full overflow-hidden"><div className="h-full bg-blue-500 rounded-full" style={{width:`${c.prog}%`}}/></div><p className="text-xs text-gray-400 mt-1 text-right">{c.prog}%</p></div>}
                </div>
              ))}
            </div>

            {/* Orders + Map Row */}
            <div className="flex gap-3 px-4 pb-4 flex-1 min-h-0">

              {/* Orders Panel */}
              <div className="w-72 flex-shrink-0 bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col overflow-hidden">
                <div className="px-4 pt-4 pb-2 flex-shrink-0">
                  <h2 className="font-bold text-gray-900 text-base mb-3">Orders</h2>
                  <div className="flex gap-1 border-b border-gray-100 pb-2">
                    {["All","In Progress","Pending","Completed"].map(f=>(
                      <button key={f} onClick={()=>setOrderFilter(f)} className={`px-2 py-1 rounded text-xs font-semibold transition-colors whitespace-nowrap ${orderFilter===f?"text-blue-700 border-b-2 border-blue-600":"text-gray-400 hover:text-gray-700"}`}>{f==="In Progress"?"In Progress":f}</button>
                    ))}
                  </div>
                </div>
                <div className="flex-1 overflow-y-auto">
                  {filteredLoads.map(load=>(
                    <OrderRow key={load.id} load={load} selected={selectedLoad?.id===load.id} onClick={()=>handleSelectLoad(load)}/>
                  ))}
                </div>
                <div className="px-4 py-3 border-t border-gray-100 flex-shrink-0">
                  <button className="text-sm text-blue-600 hover:text-blue-800 font-semibold flex items-center gap-1">View all orders →</button>
                </div>
              </div>

              {/* Live Tracking Map */}
              <div className="flex-1 bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col overflow-hidden min-w-0">
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-900">Live Tracking</span>
                    {simRunning&&<span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"/>}
                  </div>
                  <div className="flex items-center gap-1.5">
                    <button onClick={()=>setSimRunning(r=>!r)} className={`text-xs px-2.5 py-1.5 rounded-lg font-semibold border transition-colors ${simRunning?"bg-amber-50 text-amber-700 border-amber-200":"bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"}`}>{simRunning?"⏸ Pause":"▶ Start"}</button>
                    <button onClick={resetSim} className="text-xs px-2.5 py-1.5 rounded-lg font-semibold bg-gray-50 text-gray-500 border border-gray-200 hover:bg-gray-100">↺ Reset</button>
                    <button className="text-xs px-2.5 py-1.5 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 flex items-center gap-1 font-semibold">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/></svg>
                      Filter
                    </button>
                    <button onClick={openGPSRecall} className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg font-bold flex items-center gap-1.5 transition-colors">
                      📡 GPS Recall
                    </button>
                    <button className="w-8 h-8 hover:bg-gray-100 rounded-lg flex items-center justify-center text-gray-400">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/></svg>
                    </button>
                  </div>
                </div>
                <div className="flex-1 relative overflow-hidden min-h-0">
                  <TrackingMap simIdx={simIdx} simProg={simProg} simRunning={simRunning} hlDriver={null}/>
                  {simRunning&&(
                    <div className="absolute top-2 left-2 bg-white/95 border border-gray-200 rounded-xl px-3 py-2 shadow-sm text-xs space-y-1">
                      <div className="text-gray-500">Speed: <span className="font-bold text-gray-800">{simSpeed} km/h</span></div>
                      <div className="text-gray-500">ETA: <span className="font-bold text-green-700">{etaMins>0?`${Math.floor(etaMins/60)}h ${etaMins%60}m`:"Arrived"}</span></div>
                      <div className="text-gray-500">Progress: <span className="font-bold text-blue-700">{pct}%</span></div>
                    </div>
                  )}
                </div>
                <div className="px-4 py-2 border-t border-gray-100 flex-shrink-0">
                  <div className="flex justify-between text-xs text-gray-400 mb-1">
                    <span>Bakersfield, CA</span>
                    <span className="text-gray-600 font-semibold">{pct}%</span>
                    <span>Phoenix, AZ</span>
                  </div>
                  <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                    <div className="h-full rounded-full transition-all duration-300" style={{width:`${pct}%`,background:"linear-gradient(90deg,#3b82f6,#f59e0b)"}}/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT PANEL — desktop */}
          <div className="w-80 flex-shrink-0 border-l border-gray-200 bg-gray-50 flex flex-col overflow-hidden">
            <RightPanelContent/>
          </div>
        </div>

        {/* ── MOBILE BODY ── */}
        <div className="flex-1 overflow-hidden flex flex-col lg:hidden">

          {/* Mobile view switcher */}
          {mobileView==="dashboard"&&(
            <div className="flex-1 overflow-y-auto pb-16">
              {/* Summary Cards — 2 col on mobile */}
              <div className="grid grid-cols-2 gap-2 p-3">
                {summaryCards.map((c,i)=>(
                  <div key={i} className="bg-white rounded-2xl p-3 shadow-sm border border-gray-100">
                    <div className="flex items-start justify-between mb-1.5">
                      <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-base ${c.color==="blue"?"bg-blue-50":c.color==="green"?"bg-green-50":c.color==="red"?"bg-red-50":"bg-purple-50"}`}>{c.icon}</div>
                      {c.delta&&<span className={`text-xs font-semibold ${c.up?"text-green-600":"text-red-500"}`}>{c.delta}</span>}
                    </div>
                    <p className="text-[10px] text-gray-400 font-medium">{c.label}</p>
                    <p className="text-xl font-bold text-gray-900 mt-0.5">{c.val}</p>
                    {c.sub&&<p className="text-[10px] text-gray-400">{c.sub}</p>}
                    {c.prog!=null&&<div className="mt-1.5"><div className="h-1.5 bg-gray-100 rounded-full overflow-hidden"><div className="h-full bg-blue-500 rounded-full" style={{width:`${c.prog}%`}}/></div><p className="text-[10px] text-gray-400 mt-0.5 text-right">{c.prog}%</p></div>}
                  </div>
                ))}
              </div>
              {/* Orders */}
              <div className="bg-white rounded-2xl mx-3 mb-3 shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-4 pt-4 pb-2">
                  <h2 className="font-bold text-gray-900 text-base mb-2">Orders</h2>
                  <div className="flex gap-1 border-b border-gray-100 pb-2 overflow-x-auto">
                    {["All","In Progress","Pending","Completed"].map(f=>(
                      <button key={f} onClick={()=>setOrderFilter(f)} className={`px-2 py-1 rounded text-xs font-semibold whitespace-nowrap ${orderFilter===f?"text-blue-700 border-b-2 border-blue-600":"text-gray-400"}`}>{f}</button>
                    ))}
                  </div>
                </div>
                {filteredLoads.map(load=>(
                  <OrderRow key={load.id} load={load} selected={selectedLoad?.id===load.id} onClick={()=>handleSelectLoad(load)}/>
                ))}
                <div className="px-4 py-3 border-t"><button onClick={()=>setMobileView("orders")} className="text-sm text-blue-600 font-semibold">View all orders →</button></div>
              </div>
              {/* Live Tracking preview */}
              <div className="bg-white rounded-2xl mx-3 mb-3 shadow-sm border border-gray-100 overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <span className="font-bold text-gray-900">Live Tracking</span>
                  <button onClick={()=>setMobileView("map")} className="text-xs text-blue-600 font-semibold">Full Map →</button>
                </div>
                <div className="h-48 relative">
                  <TrackingMap simIdx={simIdx} simProg={simProg} simRunning={simRunning} hlDriver={null}/>
                </div>
                <div className="px-4 py-2 border-t">
                  <div className="flex justify-between text-xs text-gray-400 mb-1"><span>Bakersfield</span><span className="font-semibold text-gray-700">{pct}%</span><span>Phoenix</span></div>
                  <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden"><div className="h-full rounded-full" style={{width:`${pct}%`,background:"linear-gradient(90deg,#3b82f6,#f59e0b)"}}/></div>
                </div>
              </div>
            </div>
          )}

          {mobileView==="orders"&&(
            <div className="flex-1 overflow-hidden flex flex-col pb-16">
              <div className="bg-white border-b px-4 py-3 flex-shrink-0">
                <div className="flex items-center gap-3 mb-2">
                  <button onClick={()=>setMobileView("dashboard")} className="text-blue-600"><svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/></svg></button>
                  <h2 className="font-bold text-gray-900">Orders</h2>
                </div>
                <div className="flex gap-1 overflow-x-auto pb-1">
                  {["All","In Progress","Pending","Completed"].map(f=>(
                    <button key={f} onClick={()=>setOrderFilter(f)} className={`px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors ${orderFilter===f?"bg-blue-600 text-white":"bg-gray-100 text-gray-500"}`}>{f}</button>
                  ))}
                </div>
              </div>
              <div className="flex-1 overflow-y-auto bg-white">
                {filteredLoads.map(load=><OrderRow key={load.id} load={load} selected={selectedLoad?.id===load.id} onClick={()=>handleSelectLoad(load)}/>)}
              </div>
            </div>
          )}

          {mobileView==="map"&&(
            <div className="flex-1 flex flex-col pb-16">
              <div className="bg-white border-b px-4 py-3 flex items-center justify-between flex-shrink-0">
                <div className="flex items-center gap-3">
                  <button onClick={()=>setMobileView("dashboard")} className="text-blue-600"><svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/></svg></button>
                  <span className="font-bold text-gray-900">Live Tracking</span>
                  {simRunning&&<span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"/>}
                </div>
                <div className="flex items-center gap-1.5">
                  <button onClick={()=>setSimRunning(r=>!r)} className={`text-xs px-2.5 py-1.5 rounded-lg font-semibold border ${simRunning?"bg-amber-50 text-amber-700 border-amber-200":"bg-gray-50 text-gray-600 border-gray-200"}`}>{simRunning?"⏸":"▶ Start"}</button>
                  <button onClick={resetSim} className="text-xs px-2 py-1.5 rounded-lg font-semibold bg-gray-50 text-gray-500 border border-gray-200">↺</button>
                  <button onClick={openGPSRecall} className="text-xs bg-blue-600 text-white px-2.5 py-1.5 rounded-lg font-bold">📡 GPS</button>
                </div>
              </div>
              <div className="flex-1 relative overflow-hidden">
                <TrackingMap simIdx={simIdx} simProg={simProg} simRunning={simRunning} hlDriver={null}/>
                {simRunning&&(
                  <div className="absolute top-2 left-2 bg-white/95 border border-gray-200 rounded-xl px-3 py-2 shadow text-xs space-y-0.5">
                    <div className="text-gray-500">Speed: <span className="font-bold">{simSpeed} km/h</span></div>
                    <div className="text-gray-500">ETA: <span className="font-bold text-green-700">{etaMins>0?`${Math.floor(etaMins/60)}h ${etaMins%60}m`:"Arrived"}</span></div>
                  </div>
                )}
              </div>
              <div className="px-4 py-2 bg-white border-t flex-shrink-0">
                <div className="flex justify-between text-xs text-gray-400 mb-1"><span>Bakersfield, CA</span><span className="font-semibold text-gray-700">{pct}%</span><span>Phoenix, AZ</span></div>
                <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden"><div className="h-full rounded-full transition-all duration-300" style={{width:`${pct}%`,background:"linear-gradient(90deg,#3b82f6,#f59e0b)"}}/></div>
              </div>
            </div>
          )}

          {mobileView==="detail"&&(
            <div className="flex-1 overflow-hidden flex flex-col pb-16 bg-gray-50">
              <div className="bg-white border-b px-4 py-3 flex items-center gap-3 flex-shrink-0">
                <button onClick={()=>setMobileView("dashboard")} className="text-blue-600"><svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/></svg></button>
                <span className="font-bold text-gray-900">Detail / Chat</span>
              </div>
              <div className="flex-1 overflow-hidden flex flex-col">
                <RightPanelContent/>
              </div>
            </div>
          )}

          {/* ── MOBILE BOTTOM NAV ── */}
          <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex z-30 lg:hidden" style={{paddingBottom:"env(safe-area-inset-bottom)"}}>
            {[
              {key:"dashboard",label:"Home",   icon:"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"},
              {key:"orders",  label:"Orders",  icon:"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"},
              {key:"map",     label:"Map",     icon:"M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"},
              {key:"detail",  label:"Detail",  icon:"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"},
              {key:"chat_m",  label:"Chat",    icon:"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"},
            ].map(item=>(
              <button
                key={item.key}
                onClick={()=>{
                  if(item.key==="chat_m"){setMobileView("detail");setRightTab("chat");}
                  else setMobileView(item.key);
                }}
                className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${(mobileView===item.key||(item.key==="chat_m"&&mobileView==="detail"&&rightTab==="chat"))?"text-blue-600":"text-gray-400"}`}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                  {item.icon.split(" M").map((seg,i)=><path key={i} strokeLinecap="round" strokeLinejoin="round" d={i===0?seg:"M"+seg}/>)}
                </svg>
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── MODALS ── */}
      {gpsModal&&(
        <GPSModal simIdx={simIdx} simProg={simProg} simRunning={simRunning}
          onClose={()=>setGpsModal(false)}
          onViewMap={d=>{setGpsModal(false);setMapPopupDrv(d);}}/>
      )}
      {mapPopupDrv&&(
        <MapPopupModal driver={mapPopupDrv} simIdx={simIdx} simProg={simProg} simRunning={simRunning}
          onClose={()=>setMapPopupDrv(null)}/>
      )}
    </div>
  );
}
